
const ENV = (window as any)?._env || process.env;
export const getEnvVariable = (name: string) => ENV[name] || process.env[name];

export const envProperties = {        
    CemBaseUrl: getEnvVariable('REACT_APP_CEMBASE_URL'),
    EulaApiUrl: getEnvVariable('REACT_APP_EULABASE_URL'),
    InsightBaseUrl: getEnvVariable('REACT_APP_INSIGHT_URL'),
    IsDevToolsEnabled: getEnvVariable('REACT_APP_ENABLE_DEV_TOOLS'),
    WebBaseUrl: getEnvVariable('REACT_APP_WEBBASE_URL'),
    authentication: {
        authority: getEnvVariable('REACT_APP_AUTH_AUTHORITY'),
        clientId: getEnvVariable('REACT_APP_AUTH_CLIENTID'),
        oidcsilentRefreshTime: getEnvVariable('REACT_APP_OIDCSILENTREFRESHOFFSETTIMEINSECONDS')
    },
    manageAllWorkspacesFeature: getEnvVariable('REACT_APP_MANAGE_ALL_WORKSPACES')
};